import _ from "lodash";
import React from "react";

export const renderErrorsList = errorsObject => {
  return _.map(errorsObject, errorType => {
    return errorType.map((error, idx) => {
      return (
        <li key={idx} className="error-item">
          * {error}
        </li>
      );
    });
  });
};

export const renderOptions = (options, value, text) => {
  return options.map(option => {
    return (
      <option key={option[value]} value={option[value]}>
        {option[text]}
      </option>
    );
  });
};

export const renderSelectField = field => {
  // Utility for use with `redux-form.Field`

  const {
    meta: { touched, error }
  } = field;
  const className = `form-group ${touched && error ? "has-danger" : ""}`;

  return (
    <div className={className}>
      {(() => {
        if (!field.hideLabel) {
          return <label>{field.label}</label>;
        }
      })()}
      <select
        className={`form-control text-center ${field.className}`}
        id={field.id}
        type={field.type}
        placeholder={field.label}
        {...field.input}
      >
        {!field.hideBlankOption && <option />}
        {renderOptions(
          field.selectOptions,
          field.selectOptionValue,
          field.selectOptionText
        )}
      </select>
      <div>{touched ? error : ""}</div>
    </div>
  );
};

export const renderField = (field, textAlign = "left", customClasses = "") => {
  // Utility for use with `redux-form.Field`

  const {
    meta: { touched, error }
  } = field;
  const className = `form-group ${touched && error ? "has-danger" : ""}`;

  return (
    <div className={className}>
      {(() => {
        if (!field.hideLabel) {
          return <label>{field.label}</label>;
        }
      })()}
      {field.type === "textarea" ? (
        <textarea
          className={`form-control form-control-custom ${customClasses}`}
          id={field.id}
          placeholder={field.placeholder}
          disabled={field.disabled}
          maxLength={field.maxLength}
          rows={field.rows}
          {...field.input}
        />
      ) : (
        <input
          className={`form-control text-${textAlign} form-control-custom ${customClasses}`}
          id={field.id}
          type={field.type}
          placeholder={field.placeholder}
          disabled={field.disabled}
          {...field.input}
        />
      )}

      <div>{touched ? error : ""}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/utils/formUtils.js